export function GlassCard({ children, className = "", ...rest }) {
  return (
    <div className={`glass rounded-3xl p-8 ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function GlassCardStrong({ children, className = "", ...rest }) {
  return (
    <div className={`glass-strong rounded-3xl p-8 ${className}`} {...rest}>
      {children}
    </div>
  );
}
